import React from 'react';
import { Repeat } from 'react-feather';
import { Text, TEXT_VARIANTS } from 'ui/Typography';
import LinkButton from 'components/shared/LinkButton';

const RetryButton = ({ onClick, disabled, retry }) => (
  <LinkButton
    type="primary"
    onClick={onClick}
    disabled={disabled}
    className="p-0 mh-34 mr-4"
  >
    {disabled ? (
      <div className="d-f ai-c c-gray-dark fz-16">
        {t('common.try_again')}
        <Repeat size="1em" className="ml-4" />
      </div>
    ) : (
      <Text className="d-f ai-c" variant={TEXT_VARIANTS.BODY_LINK}>
        {retry ? t('common.retry') : t('common.try_again')}
        <Repeat size="1em" className="ml-4" />
      </Text>
    )}
  </LinkButton>
);

export default RetryButton;
